/** Desktop footer history tables — column widths aligned with TradeDesktopContent. */

export const DESKTOP_HISTORY_TABLE_CLASS =
  "table-fixed w-full text-[11px] tabular-nums [&_td]:py-0.5 [&_th]:py-0";

export const historyTh =
  "h-7 px-1.5 text-[11px] font-medium text-muted-foreground whitespace-nowrap";

/** Match open-trades body cells (`px-1.5` + column `w-*` on each cell). */
export const historyTd = "px-1.5 whitespace-nowrap";

export const HISTORY_POSITION_COL_WIDTHS = {
  openTime: "w-40",
  symbol: "w-24",
  /** Position id. Was missing entirely, so closed positions could not be tied back to a ticket. */
  ticket: "w-20",
  type: "w-20",
  lots: "w-14",
  openPrice: "w-20",
  tp: "w-16",
  sl: "w-16",
  closeTime: "w-40",
  closePrice: "w-20",
  commission: "w-16",
  swap: "w-14",
  pnl: "w-16",
  change: "w-16",
} as const;

export const HISTORY_ORDER_COL_WIDTHS = {
  open: "w-40",
  status: "w-14",
  symbol: "w-24",
  ticket: "w-20",
  type: "w-20",
  lots: "w-14",
  price: "w-20",
  tp: "w-16",
  sl: "w-16",
  exec: "w-40",
  state: "w-16",
} as const;

export const HISTORY_DEAL_COL_WIDTHS = {
  time: "w-40",
  symbol: "w-24",
  deal: "w-20",
  type: "w-20",
  direction: "w-16",
  lots: "w-14",
  price: "w-20",
  tp: "w-16",
  sl: "w-16",
  commission: "w-16",
  pnl: "w-16",
  change: "w-16",
} as const;
